<template>
  <g data-name="Gruppe 1687">
    <g data-name="Gruppe 1609">
      <g data-name="Gruppe 1607">
        <g data-name="Gruppe 1010">
          <g
            data-name="Gruppe 1009"
            transform="translate(7.486 4.99)"
          >
            <rect
              data-name="Rechteck 1047"
              width="14.952"
              height="1.8"
              rx=".9"
              fill="current"
            />
          </g><g
            data-name="Gruppe 1012"
            transform="translate(1.562 4.99)"
          >
            <rect
              data-name="Rechteck 1048"
              width="3.773"
              height="1.8"
              rx=".9"
              fill="current"
            />
          </g>
        </g><g data-name="Gruppe 1010">
          <g
            data-name="Gruppe 1009"
            transform="translate(7.486 11.1)"
          >
            <rect
              data-name="Rechteck 1047"
              width="14.952"
              height="1.8"
              rx=".9"
              fill="current"
            />
          </g><g
            data-name="Gruppe 1012"
            transform="translate(1.562 11.1)"
          >
            <rect
              data-name="Rechteck 1048"
              width="3.773"
              height="1.8"
              rx=".9"
              fill="current"
            />
          </g>
        </g><g data-name="Gruppe 1010">
          <g
            data-name="Gruppe 1009"
            transform="translate(7.486 17.21)"
          >
            <rect
              data-name="Rechteck 1047"
              width="14.952"
              height="1.8"
              rx=".9"
              fill="current"
            />
          </g><g
            data-name="Gruppe 1012"
            transform="translate(1.562 17.21)"
          >
            <rect
              data-name="Rechteck 1048"
              width="3.773"
              height="1.8"
              rx=".9"
              fill="current"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
</template>